import * as fastspring from './fastspring';
import * as paddle from './paddle';
import * as twoCheckout from './2checkout';

const STORES = Object.freeze({
  PADDLE: 'PADDLE',
  FASTSPRING: 'FASTSPRING',
  TWOCHECKOUT: '2CHECKOUT',
})

const selectedStore = STORES.TWOCHECKOUT;

const currentStore = () => {
  
  if (selectedStore === STORES.FASTSPRING) {
    return fastspring;
  }

  if (selectedStore === STORES.PADDLE) {
    return paddle;
  }

  if (selectedStore === STORES.TWOCHECKOUT) {
    return twoCheckout;
  }
  throw new Error('Invalid store');
}

export const fetchProPrice = (quantity = 1, options) => currentStore().fetchProPrice(quantity, options);
export const fetchEnterprisePrice = (quantity = 1, options) => currentStore().fetchEnterprisePrice(quantity, options);

export const fetchProRenewalPrice = (quantity = 1, options) => currentStore().fetchProRenewalPrice(quantity, options);
export const fetchEnterpriseRenewalPrice = (quantity = 1, options) => currentStore().fetchEnterpriseRenewalPrice(quantity, options);

export const ProCheckout = (quantity = 1, options) => currentStore().ProCheckout(quantity, options);
export const isProCheckoutUrl = () => currentStore().isProCheckoutUrl;
export const enterpriseCheckout = (quantity = 1, options) => currentStore().enterpriseCheckout(quantity, options);
export const ProRenewalCheckout = (quantity = 1, durationInYears = 1, options) => currentStore().ProRenewalCheckout(quantity, durationInYears, options);
export const enterpriseRenewalCheckout = (quantity = 1, durationInYears = 1, options) => currentStore().enterpriseRenewalCheckout(quantity, durationInYears, options);

